export default __webpack_public_path__ + "2d6ceaa7ea24cc62dd48069322fd10c8.svg";